<div class="container">
  @let driverReports = swapPoint().driverReports;
  @let inProgress = driverReports?.['in-progress'];

  <div class="statuses">
    <ng-container
      *ngTemplateOutlet="
        headingSectionTemplate;
        context: {
          report: driverReports?.waiting,
          heading: 'labels.waiting',
          start: driverReports?.waiting?.createdAt,
          finish: inProgress?.createdAt ?? swapPoint().timestamps.startedAt,
        }
      "
    ></ng-container>

    @let completed = driverReports?.completed;
    <ng-container
      *ngTemplateOutlet="
        headingSectionTemplate;
        context: {
          report: inProgress,
          heading: 'map.swapPanel.change',
          start: inProgress?.createdAt,
          finish: completed?.createdAt ?? swapPoint().timestamps.completedAt,
        }
      "
    ></ng-container>

    @if (inProgressFiles().length) {
      <ng-container
        *ngTemplateOutlet="
          filesContainerTemplate;
          context: { files: inProgressFiles() }
        "
      ></ng-container>
    }
  </div>

  @if (completedFiles().length) {
    <ng-container
      *ngTemplateOutlet="
        filesContainerTemplate;
        context: { files: completedFiles() }
      "
    ></ng-container>
  }
</div>

<ng-template let-files="files" #filesContainerTemplate>
  <div class="files-container">
    @for (item of files; track item) {
      @if (item.files.length) {
        <app-driver-report-modal-image
          [filesData]="files"
          [files]="item.files"
          [title]="item.title"
          [note]="item.note"
        ></app-driver-report-modal-image>
      }
    }
  </div>
</ng-template>

<ng-template
  let-report="report"
  let-heading="heading"
  let-start="start"
  let-finish="finish"
  #headingSectionTemplate
>
  @if (report) {
    <div class="item">
      <onyx-information-heading [identifierColor]="identifierColor()">
        {{ heading | translate }}

        <span subheading class="f-muted">
          {{ start | onyxTime }}-{{
            finish ? `${(finish | onyxTime)}` : `${('labels.now' | translate)}`
          }}
          ·
          {{ start | onyxDate: 'date' : { endDate: finish } }}
        </span>
      </onyx-information-heading>

      @if (report.note; as note) {
        <div class="note">
          <p class="content" [class.f-muted]="note">{{ note }}</p>
        </div>
      } @else {
        <span class="f-muted">
          {{ 'labels.missingNote' | translate }}
        </span>
      }
    </div>
  } @else {
    <onyx-information-heading [identifierColor]="identifierColor()">
      {{ heading | translate }}

      <span subheading class="f-muted">
        {{ 'labels.noReport' | translate }}
      </span>
    </onyx-information-heading>
  }
</ng-template>
